var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sort"
  }, [_vm.availability ? _c('div', {
    staticClass: "sort__title"
  }, [_vm._v("\n    Сортировать\n    "), _c('Checkbox', {
    staticClass: "ml-6",
    attrs: {
      "checked": _vm.availability
    },
    on: {
      "change": _vm.onAvailabilityChange
    }
  }, [_vm._v("\n      с учетом наличия:\n    ")])], 1) : _c('div', {
    staticClass: "sort__title"
  }, [_vm._v("\n    Сортировать:\n  ")]), _vm._v(" "), _vm._l(_vm.list, function (el) {
    return _c('div', {
      key: el.value,
      staticClass: "sort__el",
      class: [{
        sort__el_active: _vm.value.value === el.value
      }],
      attrs: {
        "data-e2e": "sort-el"
      },
      on: {
        "click": function ($event) {
          return _vm.onSort(el);
        }
      }
    }, [_vm._v("\n    " + _vm._s(el.name) + "\n  ")]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }